export const validateFieldData = (type: string, value: unknown): unknown => {
  if (!value || typeof value !== type) return "";

  return value;
};
